<template>
    <div>
        <el-switch v-model="value"></el-switch>
    </div>
</template>

<script>
import articleApi from '../models/article'

export default {
    props: {
        row: {
            type: Object,
            default: () => {},
        },
        item: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            value: this.row[this.item.prop],
            catch_change: true,
        }
    },
    watch: {
        async value(val, oldVal) {
            if(this.catch_change) {
                try {
                    this.row[this.item.prop] = val
                    const res = await articleApi.updateDisplay(this.row.id, this.row)
                    if (res.error_code === 0) {
                        this.$message.success(`${res.msg}`)
                    }else{
                        this.catch_change = false;
                        this.value = oldVal
                    }
                } catch (error) {
                    console.log(error)
                    this.catch_change = false;
                    this.value = oldVal
                }
            }else{
                this.catch_change = true;
            }
        }
    },
}
</script>
